<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Waters Contracting</h1>
                <p>
                    Our goal at Waters Contracting is to provide you with a worry-free, low maintenance landscape and irrigation system. We accomplish this by providing you with the highest quality products, excellent design, superior installation, and outstanding service.
                </p>
                <div>
                  <b-card no-body>
                    <b-card-body>
                      <b-card-title>Irrigation</b-card-title>
                      <b-card-sub-title class="mb-2">Irrigation is our speciality</b-card-sub-title>
                      <b-card-text>
                        Irrigation systems aka 'sprinkler systems' provide your plants with the water they need in this harsh desert climate.
                        We specialize in effecient systems desgined to conserve water and lower costs.
                        Below are some of irrigation related services we offer.
                      </b-card-text>
                    </b-card-body>
                    <b-list-group flush style="text-align:left">
                      <b-list-group-item>Design</b-list-group-item>
                      <b-list-group-item>Installation</b-list-group-item>
                      <b-list-group-item>Renovations</b-list-group-item>
                      <b-list-group-item style="font-weight:bold;">Repair</b-list-group-item>
                      <b-list-group-item style="font-weight:bold;">Backflow installation, servicing, and testing</b-list-group-item>
                      <b-list-group-item style="font-weight:bold;">Irrigation Auditing</b-list-group-item>
                      <b-list-group-item>Startups</b-list-group-item>
                      <b-list-group-item>Winterizing</b-list-group-item>
                      <b-list-group-item>Sytem Tune ups</b-list-group-item>
                      <b-list-group-item>Electrical Troubleshooting</b-list-group-item>
                    </b-list-group>
                  </b-card>
                  <b-card no-body>
                    <b-card-body>
                      <b-card-title>Landscaping</b-card-title>
                      <b-card-sub-title class="mb-2">Landscaping is what makes your home beautiful</b-card-sub-title>
                      <b-card-text>
                        Landscaping includes everything around your home. Softscapes such grass, plants, and trees.
                        As well as hardscapes such as patios, retaining walls, and fences.
                        Below are some of landscaping related services we offer.
                      </b-card-text>
                    </b-card-body>
                    <b-list-group flush style="text-align:left">
                      <b-list-group-item>Design</b-list-group-item>
                      <b-list-group-item>Installation</b-list-group-item>
                    </b-list-group>
                  </b-card>
                  <b-card no-body>
                    <b-card-body>
                      <b-card-title>Services</b-card-title>
                      <b-card-sub-title class="mb-2">Sometimes you need help with the big stuff</b-card-sub-title>
                      <b-card-text>
                        <p>
                          We offer the following services for the DIYer. Our tracators are perfect for exsiting landscape and small yards. The Bocat 320 and a Ditch Witch 850, measures 42-inches wide and fits in hard to reach spaces without tearing up your yard. We can provide irrigataion consulting and installation assistance for an additional cost. We can assist DIY installation by providing a detailed drawing of your yard and irrigation system. Our landscape trailer contains all the parts and tools need to install your sprinkler sytem. We can help you install your sprinkler system properly and efficiently.
                        </p>
                      </b-card-text>
                      <b-button href="/services/schedule" variant="primary">Schedule a service</b-button>
                    </b-card-body>
                    <b-list-group flush style="text-align:left">
                      <b-list-group-item>Hauling</b-list-group-item>
                      <b-list-group-item>Tractor</b-list-group-item>
                      <b-list-group-item>Pipe Pulling</b-list-group-item>
                      <b-list-group-item>Trenching</b-list-group-item>
                      <b-list-group-item>Post Holes</b-list-group-item>
                      <b-list-group-item>Horizontal Boring</b-list-group-item>
                    </b-list-group>
                  </b-card>
                  <b-card no-body>
                    <b-card-body>
                      <b-card-title>Services we no longer offer</b-card-title>
                      <b-card-sub-title class="mb-2">Sometimes you just have to move on</b-card-sub-title>
                      <b-card-text>
                        We have been in business for a long time(over 30 years).
                        Over the year we have found that there are services where we can offer the best quality at the best rates.
                        With other services we are not able to do that so we no longer offer the sercives listed below.
                      </b-card-text>
                    </b-card-body>
                    <b-list-group flush style="text-align:left">
                      <b-list-group-item>Lawn care</b-list-group-item>
                      <b-list-group-item>Weekly weeding</b-list-group-item>
                      <b-list-group-item>Tree Maintenance</b-list-group-item>
                    </b-list-group>
                  </b-card>
                </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Services2',
}
</script>